import type React from 'react';

import type { LinkListClickOpts } from './types';

interface LinkClickHandlers {
	onAuxClick: ((e: React.MouseEvent) => void) | undefined;
	onClick: (() => void) | undefined;
	onContextMenu: ((e: React.MouseEvent) => void) | undefined;
}

export const createLinkClickHandlers = (
	onLinkClick: ((url: string, idx: number, opts?: LinkListClickOpts) => void) | undefined,
	url: string,
	idx: number,
): LinkClickHandlers => {
	if (!onLinkClick) {
		return { onClick: undefined, onAuxClick: undefined, onContextMenu: undefined };
	}

	return {
		onClick: () => onLinkClick(url, idx),
		onAuxClick: (e: React.MouseEvent) => {
			if (e.button === 1) {
				onLinkClick(url, idx, { isAuxClick: true });
			}
		},
		onContextMenu: (_e: React.MouseEvent) => onLinkClick(url, idx, { isContextMenu: true }),
	};
};
